import { render, staticRenderFns } from "./ModelSharePlatform.vue?vue&type=template&id=489c1580&scoped=true"
import script from "./ModelSharePlatform.vue?vue&type=script&lang=js"
export * from "./ModelSharePlatform.vue?vue&type=script&lang=js"
import style0 from "./ModelSharePlatform.vue?vue&type=style&index=0&id=489c1580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c1580",
  null
  
)

export default component.exports